<div  fxLayout="row" fxLayoutAlign="start end" style="margin-bottom:10px">
    <div fxFlex="50"></div>
    <div fxFlex="50">
        <button mat-icon-button (click)="onNoClick()"><mat-icon color="warn"> close</mat-icon></button>
    </div>
</div>
<div style="text-align:center">
    <img [src]="imageSrc" style="width:100%; height:400px">
</div>